import axios from 'axios'

if (process.env.NODE_ENV !== "development") {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
}

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.transformRequest = [
  function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }
]

axios.create({
  timeout: 20000, // 请求超时时间
  withCredentials: true,
  headers: {
    //关键
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
})

// axios.interceptors.request.use(config => {
//   // 为请求头添加Authorization字段为服务端返回的token
//   if (Vue.$cookies.get("token")) {
//     let {
//       access_token
//     } = Vue.$cookies.get("token")
//     config.headers.Authorization = access_token
//     return config
//   }
//   return config
// })

const $http = function (api, params) {
  if (api.type === 'get') {
    return axios.get(api.url, {
      params
    })
  } else if (api.type === 'post') {
    return axios.post(api.url, params || {})
  }
}

export default $http



// WEBPACK FOOTER //
// ./src/utils/http.js